module.exports = __webpack_public_path__ + "static/media/github-screenshot.36ed17d0.jpg";